<a routerLink="home"><img src="/assets/ng-todo-logo.png" alt="Logo" /></a>
<app-nav></app-nav>
